export const hubSpotUrl = () => {
	const appId = process.env.VUE_APP_HUBSPOT_APP_ID;
	return `https://app.hubspot.com/contacts/${appId}`;
};
